import { eTipoPermissao } from '@/enums/ePermissoes';
export default [
    {
        description: 'Forma de Aquisição',
        path: '/biblioteca/bibformaaquisicao',
        name: 'bibformaaquisicao',
        component: () => import('@/views/biblioteca/bibformaaquisicao/Index.vue'),
        meta: {
            permissions: [eTipoPermissao.BIB_FORMASDEAQUISICAONOVO_MENU_1300801099],
        },
        goesToMenu: true,
    },
    {
        description: 'Cadastro de Forma de Aquisição',
        path: '/biblioteca/bibformaaquisicao/cadastro/:id?',
        parent: 'bibformaaquisicao',
        name: 'bibformaaquisicao_create',
        component: () => import('@/views/biblioteca/bibformaaquisicao/InclusaoEdicao.vue'),
        meta: {
            permissions: [eTipoPermissao.BIB_FORMASDEAQUISICAONOVO_MENU_1300801099],
        },
        goesToMenu: true,
    },
]
